<script lang="ts">
  export let error: Error;
</script>

<p
  class="alert alert-danger mt-3 animate__animated animate__jello"
  role="alert"
>
  {error}
</p>
